import { toRaw } from "vue";

const productPageStateComputedMixin = {
  computed: {
    productDetails() {
      return toRaw(this.$store.state.productPage.productData.productDetails);
    },
    productBrandImage() {
      return toRaw(this.$store.state.productPage.productData.productBrandImage);
    },
    priceAvailability() {
      return toRaw(this.$store.state.productPage.productData.priceAvailability);
    },
    productUpdatePathUrl() {
      return toRaw(this.$store.state.productPage.productData.productUpdatePathUrl);
    },
    referToAFriendUrl() {
      return toRaw(this.$store.state.productPage.productData.referToAFriendUrl);
    },
    reviewFormUrl() {
      return toRaw(this.$store.state.productPage.productData.reviewFormUrl);
    },
    addToBasketUrl() {
      return toRaw(this.$store.state.productPage.productData.addToBasketUrl);
    },
    addWithPrintToBasketUrl() {
      return toRaw(this.$store.state.productPage.productData.addWithPrintToBasketUrl);
    },
    productReminderUrl() {
      return toRaw(this.$store.state.productPage.productData.productReminderUrl);
    },
    lastSeenItems() {
      return toRaw(this.$store.state.productPage.productData.lastSeenItems);
    },
    possibleAlternatives() {
      return toRaw(this.$store.state.productPage.productData.possibleAlternatives);
    },
    qualityKeys() {
      return toRaw(this.$store.state.productPage.productData.qualityKeys);
    },
    navigationItems() {
      return toRaw(this.$store.state.productPage.productData.navigationItems);
    },
    productFlags() {
      return toRaw(this.$store.state.productPage.productData.productFlags);
    },
    longDescription() {
      return toRaw(this.$store.state.productPage.productData.longDescription);
    },
    referToAFriendShow() {
      return toRaw(this.$store.state.productPage.productData.referToAFriendShow);
    },
    captchaImg() {
      return toRaw(this.$store.state.productPage.productData.captchaImg);
    },
    currentGalleryIndex() {
      return toRaw(this.$store.state.productPage.productData.currentGalleryIndex);
    },
    initPhotoSwipe() {
      // problem of initialization of components needs to be fixed: initPhotoSwipe must return true
      return toRaw(this.$store.state.productPage.productData.initPhotoSwipe || true);
    },
    videos() {
      return toRaw(this.$store.state.productPage.productData.videos);
    },
    // brandSeoText() {
    //   return toRaw(this.$store.state.productPage.productData.brandSeoText);
    // },
    adsHashForwardPath() {
      return toRaw(this.$store.state.productPage.productData.adsHashForwardPath);
    },
    sellingPoints() {
      return this.$store.state.productPage.productData.sellingPoints
    },
    quantityPerPalette() {
      return this.$store.state.productPage.productData.productDetails.product.quantityPerPalette
    },
    variations() {
      return this.$store.state.productPage.productData.productDetails.product.variations
    },
  }
}

export default productPageStateComputedMixin;
